<div>
    <table>
        <tr>
            <td class="logo"><img alt="page logo" src="assets/logo2t.png"></td>
            <td class="title"><h1> Only the best of Youtube .com</h1></td>
        </tr>
    </table>
</div>
